module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{"title":"Integración de servicios de pago adaptados a tus necesidades técnicas y de negocio.","btnNames":[{"b1":"INTEGRACIÓN DE","b2":"FORMULARIO"},{"b1":"INTEGRACIÓN DE","b2":"FORMULARIO INFRAME"},{"b1":"INTEGRACIÓN DE","b2":"SERVIDOR O DIRECTA"}]}}')
  delete Component.options._Ctor
}
